import { SelectHelperMenuItem } from 'bold-ui'
import { CustomSingleSelectFieldProps, SelectField } from 'components/form/final-form'
import { useMemo } from 'react'

import { useMediaDevices } from '../hooks/useMediaDevices'
import { DispositivoMidiaSelectModel } from '../model-videochamada'

export type DispositivoMidiaSelectFieldProps = CustomSingleSelectFieldProps<DispositivoMidiaSelectModel> & {
  tipo: 'audioinput' | 'videoinput' | 'audiooutput'
  emptyMessage: string
}

const itemToString = (item: DispositivoMidiaSelectModel) => item && item.nome

export function DispositivoMidiaSelectField(props: DispositivoMidiaSelectFieldProps) {
  const { tipo, emptyMessage, ...rest } = props

  const mediaDevices = useMediaDevices({ deviceType: tipo })

  const items = useMemo(
    () =>
      mediaDevices
        .map((device) => ({
          id: device.deviceId,
          nome: device.label || `Dispositivo ${device.deviceId}`,
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome)),
    [mediaDevices]
  )

  return (
    <SelectField<DispositivoMidiaSelectModel>
      items={items}
      itemToString={itemToString}
      components={{
        EmptyItem: () => <SelectHelperMenuItem>{emptyMessage}</SelectHelperMenuItem>,
      }}
      {...rest}
    />
  )
}
